// @flow
import * as React from "react"
import "../../config/analytics"
import "hamburgers/dist/hamburgers.min.css"
import { OverlayMenu } from "../OverlayMenu"
import { OverlayMenuItem } from "../OverlayMenuItem"
import { Wrapper, WrapperMobile, overlayClassName } from "./style"
import { tRouteProps } from "../../types"
import { breakpoints, color } from "../../styles/variables"
import { css } from "react-emotion/macro"
import { Dropdown } from "../Dropdown"
import { hot } from "react-hot-loader"
import { SearchIcon } from "../Icons/SearchIcon"
import { AngoliaSearch } from "../AlgoliaSearch"
import { searchOverlay } from "../../styles/angoliaSearch"
import { Container } from "../StyledComponents"
import algoliaLogo from "../AlgoliaSearch/logo.svg"
import { Link } from "../Link"

const MobileBar = (props) => (
  <React.Fragment>
    <div className="left">
      <Link to="/" className="logo-wrapper">
        <img
          src={props.routeProps.brand.logo.url}
          alt={props.routeProps.brand.logo.alt}
        />
      </Link>
    </div>
    <div className="right">
      <span
        className={css`
          margin-right: 15px;
        `}
      >
        <MyCSL />
      </span>
      <button
        className={`hamburger hamburger--collapse show-mobile ${
          props.overlayIsActive ? "is-active" : ""
        }`}
        type="button"
        onClick={props.toggleOverlay}
      >
        <span className="hamburger-box">
          <span className="hamburger-inner" />
        </span>
      </button>
    </div>
  </React.Fragment>
)

const Search = hot(module)(() => (
  <React.Fragment>
    <AngoliaSearch
      className={searchOverlay}
      toggler={({ setIsActive }) => (
        <button
          onClick={() => setIsActive(true)}
          className={css`
            border: none;
            background: none;
            padding: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            &:hover {
              svg {
                transform: scale(1.15);
              }
            }
            svg path {
              fill: ${color.rgb.black[0]};
            }

            svg {
              width: 15px;
              height: auto;
              transition: transform 0.5s ease;
            }
          `}
        >
          <SearchIcon />
        </button>
      )}
    >
      {({ CloseButton, SearchBox, Hits }) => (
        <Container>
          <CloseButton className="btn btn-orange" />
          <h2>Search</h2>
          <div className="search-container">
            <SearchBox />
            <Hits
              hitComponent={({ hit }) =>
                hit.title && hit.path ? (
                  <Link to={hit.path}>
                    <div className="title">{hit.title}</div>
                    <div className="meta">
                      {hit.meta &&
                        hit.meta.length > 0 &&
                        hit.meta.map((item, i) => <span key={i}>{item}</span>)}
                    </div>
                  </Link>
                ) : null
              }
            />
          </div>
          <div className="logo-wrapper">
            <img src={algoliaLogo} alt="Search by: Algolia" />
          </div>
        </Container>
      )}
    </AngoliaSearch>
  </React.Fragment>
))

const MyCSL = () => (
  <a
    className={css`
      text-transform: uppercase;
      font-size: 14px;
    `}
    href="https://secure.spiritualliving.org/np/clients/spiritualliving/login.jsp"
  >
    MyCSL Login
  </a>
)

const HeaderCtas = props => props.buttons.map((button, i) => button.link && button.label ?
  <a key={i} href={button.link} className="btn btn-orange">
    {button.label}
  </a>
: <React.Fragment key={i} />)

class HeaderInner extends React.Component {
  componentDidMount = () => {
    if (typeof document !== "undefined") {
      window.addEventListener("resize", this.handleWindowResize, false)
    }
  }
  componentWillUnmount = () => {
    if (typeof document !== "undefined") {
      window.removeEventListener("resize", this.handleWindowResize, false)
    }
  }
  handleWindowResize = () => {
    this.setState({ isMobile: this.getIsMobile() })
  }
  getIsMobile = () => {
    if (
      typeof document !== "undefined" &&
      window.matchMedia(`(min-width: ${breakpoints.md}px)`).matches
    ) {
      return false
    }
    return true
  }
  toggleOverlay = () => {
    this.setState((prevState) => ({
      overlayIsActive: !prevState.overlayIsActive
    }))
  }
  initialState = {
    isMobile: this.getIsMobile(),
    overlayIsActive: false
  }
  state = this.initialState
  render() {
    const { brand } = this.props.routeProps
    return (
      <div
        className={css`
          border-bottom: 1px solid ${color.rgb.gray[2]};
          background-color: ${color.rgb.white[0]};
          position: sticky;
          top: 0;
        `}
        style={{ zIndex: "9999" }}
      >
        <Container>
          {this.state.isMobile ? (
            <WrapperMobile>
              <MobileBar
                {...this.props}
                brand={brand}
                overlayIsActive={this.state.overlayIsActive}
                toggleOverlay={this.toggleOverlay}
              />
              <OverlayMenu
                isActive={this.state.overlayIsActive}
                items={this.props.routeProps.menuItems}
                className={overlayClassName}
                aboveMenuRender={() => (
                  <div className="above">
                    <MobileBar
                      {...this.props}
                      brand={brand}
                      overlayIsActive={this.state.overlayIsActive}
                      toggleOverlay={this.toggleOverlay}
                    />
                  </div>
                )}
                belowMenuRender={() => (
                  <div className="below">
                    <div className="btns-wrapper">
                      <HeaderCtas buttons={brand.header_buttons} />
                      <Search />
                    </div>
                  </div>
                )}
                itemRender={(itemProps) => <OverlayMenuItem {...itemProps} />}
              />
            </WrapperMobile>
          ) : (
            <div
              className={css`
                background-color: #fff;
              `}
            >
              <Wrapper>
                <Link to="/" className="logo-wrapper">
                  <img src={brand.logo.url} alt={brand.logo.alt} />
                </Link>
                <div className="bars">
                  <div className="top">
                    <MyCSL />
                    <HeaderCtas buttons={brand.header_buttons} />
                  </div>
                  <div className="bottom">
                    {this.props.routeProps.menuItems.length > 0 && (
                      <ul className="header-menu-desktop">
                        {this.props.routeProps.menuItems.map((item) => (
                          <li key={item.title}>
                            <Dropdown title={item.title} items={item.items} />
                          </li>
                        ))}
                        <li
                          className={css`
                            display: flex;
                            align-items: center;
                            margin-left: -15px;
                          `}
                        >
                          <Search />
                        </li>
                      </ul>
                    )}
                  </div>
                </div>
              </Wrapper>
            </div>
          )}
        </Container>
      </div>
    )
  }
}

export const Header = hot(module)(HeaderInner)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Header/index.js